/**
 * Decorators are like angular directives pretty much. Can add functionality to an element in the dom.
 */
define('services/ractive_decorators',['require'],function (require) {
    'use strict';
    return {
        /**
         * For big chunks of ractive views that are static html, just load in html from the server
         * e.g. <div decorator="loadstatic:path/within/templates/to/my/file">Loading static html...</div>
         */
        loadstatic: function (node, content) {
            $(node).load('/fe/templates/{0}.html'.format(content));
            return {
                teardown: $.noop
            };
        },

        /**
         * Pass me the keypath, and I will make a box that allows simple math inside the textbox
         * Note we initially set with value. After that, the change event handles updating the value for that keypath
         * @param {textbox element} node 
         * @param {string} keypath
         * @returns {decorator} 
         */
        calculator: function (node, keypath) {
            var $this = $(node);
            $this.val(this.get(keypath));
            
            /**
             * Evaluate the expression in the box for manual booking number crunchin'
             * Note that we only allows numbers, "-", "+", "/", "*", and ".", spaces, and tabs
             */
            var onNumberBoxChange = function () {
                var value = $this.val().replace(/[^\d\-\/\*\s\t\.\+]/g, '');
                var evaluatedValue = eval(value); // jshint ignore:line
                this.set(keypath, evaluatedValue);
                $this.val(evaluatedValue);
            }.bind(this);

            $this.on('change', onNumberBoxChange);
            return {
                teardown: function() {
                    $this.off('change', onNumberBoxChange);
                }
            };
        },

        /* Remove some special characters and unicode characters from textbox
         * @param {textbox element} node 
         * @param {string} keypath
         * @returns {decorator} 
         */
        removeUnicodeAndCharacters: function (node, keypath) {
            var $this = $(node);
            $this.val(this.get(keypath));
            
            /**
             * Evaluate the expression in the box for manual booking textboxin' 
             * Note that we strip out any html type tags that are found
             */
            var onTextBoxChange = function () {
                // remove special characters
                var value = $this.val().replace(/[\#+~*<>{}]/g, '');
                // remove unicode
                value = value.replace(/[\u{0080}-\u{FFFF}]/gu, '');
                this.set(keypath, value);
                $this.val(value);
            }.bind(this);

            $this.on('change', onTextBoxChange);
            return {
                teardown: function() {
                    $this.off('change', onTextBoxChange);
                }
            };
        },
    };
});
